/* eslint-disable no-unused-vars */
import { Button, Form, message } from "antd";
import React, { useState, useEffect } from "react";
import Alert from "../../../../components/Alerts";

import FormComponent from "../../../../components/FormComponent";
import { HeaderWithBottomLine } from "../HeaderWithBottomLine";
import DeliveryDynamicInput from "./DeliveryDynamicInput";

import { useDispatch, useSelector, shallowEqual } from "react-redux";
import {
  patchOnboardForm,
  patchOnboardFormClear,
} from "../../../../actionsMethods/masterMethods";
import { useLocation } from "react-router";
import { useNavigate } from "react-router";
import "./style.scss";

function DeliveryDetails({
  screen,
  currentScreen,
  cpPirview,
  onChange,
  reRenderCallback,
  apiResponse,
  callBack,
}) {
  let userData = JSON.parse(localStorage.getItem("userinfo"));

  const [formValues, setFormValues] = useState([
    {
      id: Math.random().toString(36).slice(2),
      pinCode: "",
      areaName: [],
      disabledAreaName: [],
    },
  ]);

  const [alertData, setAlertData] = useState(false);
  const [submitDisable, SubmitDisable] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const history = useLocation();

  const [form] = Form.useForm();

  const { error, result, fetching } = useSelector(
    (state) => state.masterReducer.patchOnboardFormReducer,
    shallowEqual
  );

  useEffect(() => {
    let arr = apiResponse?.premiseDto?.deliveryPincodes;
    form.setFieldValue("CPPin", apiResponse?.premiseDto?.pincode);
    if (apiResponse?.premiseDto?.deliveryPincodes?.length !== 0) {
      let temp = [];
      for (let i = 0; i < arr?.length; i++) {
        temp.push({
          id: Math.random().toString(36).slice(2),
          pinCode: "",
          areaName: [],
          disabledAreaName: [],
        });
      }
      setFormValues(temp);
      for (let j = 0; j < temp?.length; j++) {
        form.setFields([
          {
            name: "CPPin" + temp[j].id,
            value: arr[j].deliveryPin,
            errors: ["Invalid Pincode"],
          },
        ]);
        form.setFieldValue(
          "service" + temp[j].id,
          arr[j].pincodeServiceabilityType
        );
        // if (arr[j].deliveryPin.length == 6) {

        // }
        form.setFieldValue("Areaname" + temp[j].id, arr[j].serviceableAreas);
        // form.setFields([
        //   {
        //     name: ["CPPin" + temp[j].id], // Adjust the field name as needed
        //     errors: ["Invalid Pincode"],
        //   },
        // ]);
      }
      // form.setFieldValue("CPPin" + 0, apiResponse?.premiseDetails?.pincode);s
    } else {
      setFormValues([
        {
          id: Math.random().toString(36).slice(2),
          pinCode: "",
          areaName: [],
          disabledAreaName: [],
        },
      ]);
    }
    callFunction();
  }, [apiResponse, currentScreen]);

  const callFunction = () => {
    const getRes = form.getFieldValue();
  };

  useEffect(() => {
    if (
      result !== null &&
      result?.cpDetails?.premiseDetails["areas"] !== null &&
      currentScreen === 4 &&
      cpPirview === true
    ) {
      setAlertData({
        visible: true,
        message: "CP boarded successfully",
      });

      setTimeout(() => {
        navigate("", {
          state: { screen: 0 },
        });
        localStorage.setItem("refreshData", null);
        screen(0);
        onChange("2");
        patchOnboardFormClear();
        reRenderCallback();
        setFormValues([
          {
            id: Math.random().toString(36).slice(2),
            pinCode: "",
            areaName: [],
            disabledAreaName: [],
          },
        ]);
      }, 3000);
      // callBack(null);
      // message.success("CP boarded successfully");
    }
    if (error !== null && currentScreen === 4) {
      message.error(error.message);
    }
  }, [fetching]);

  const onSubmitFormData = (values) => {
    let tempArea = [];
    for (let k = 0; k < formValues.length; k++) {
      tempArea.push({
        cpPincode: values?.CPPin,
        pincodeServiceabilityType: values["service" + formValues[k].id],
        deliveryPin: values["CPPin" + formValues[k].id],
        serviceableAreas: values["Areaname" + formValues[k].id],
        nonServiceableAreas: "na1, na2",
      });
    }
    let cloneData = { ...history?.state?.premiseDetails };
    delete cloneData.emailId;
    let data2 = {
      deliveryDetailsDtos: tempArea,
    };
    dispatch(
      // patchOnboardForm(data2, history?.state?.premiseDetails?.premiseId)
      patchOnboardForm(data2, userData?.userName, apiResponse?.premiseId)
    );
  };
  const formProps = {
    name: "DelivrtyDetails",
    className: "register-form",
    initialValues: {
      //   layout: formLayout,
    },
    onFinish: onSubmitFormData,
    autoComplete: "off",
  };
  const formLayout = "vertical";

  const backPage = () => {
    screen(3);
  };

  return (
    <div className="delivery-details-container">
      {alertData && <Alert alertData={alertData} />}

      <div>
        <div className="form-contener-inner">
          <div className="form-contener-priview">
            <>
              <HeaderWithBottomLine text={"Delivery Details"} icon={false} />
              <div style={{ padding: "20px 0" }}>
                <FormComponent
                  formProps={formProps}
                  formLayout={formLayout}
                  form={form}
                >
                  <DeliveryDynamicInput
                    form={form}
                    formValues={formValues}
                    setFormValues={setFormValues}
                    screen={screen}
                    SubmitDisable={SubmitDisable}
                  />
                </FormComponent>
              </div>
            </>
          </div>
        </div>

        <div className="button-container1">
          <div className="steps-action">
            <Button className="back-button" onClick={() => backPage()}>
              {"BACK"}
            </Button>
            <Button
              htmlType="submit"
              className="next-button"
              form="DelivrtyDetails"
              key="submit"
              disabled={submitDisable}
            >
              {"Submit"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeliveryDetails;
